<template>
    <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="name" item-value="id" :item-value="itemValue" :label="label"
                     v-if="loading" :required="required" :placeholder="placeholder" @change="onColorSelected"/>
</template>

<script>
    import {getAllHorseColors} from "@/swagger/vue-api-client";
    import CustomSelectOne from "./inner/CustomSelectOne";

    export default {
        name: "CustomSelectOneHorseColor",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            modelValue: null,
            itemValue: {
                type: String,
                default: "name",
            },
            damColorName: {
                type: String,
                default: null,
            },
            sireColorName: {
                type: String,
                default: null,
            },
            triggerValidation: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue", "validation-result"],

        watch: {
            triggerValidation() {
                this.onColorSelected(this.modelValue);
            },
            damColorName() {
                // Trigger validation when dam color changes
                this.onColorSelected(this.modelValue);
            },
            sireColorName() {
                // Trigger validation when sire color changes
                this.onColorSelected(this.modelValue);
            },
        },

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            getAllHorseColors().then((response) => {
                this.items = response.data;
                this.loading = true;
            });
        },

        methods: {
            onColorSelected(colorId) {
                if (!colorId || !this.damColorName || !this.sireColorName) {
                    this.$emit("validation-result", true);
                } else {
                    const selectedColor = this.items.find((i) => i.id === colorId);

                    const damColor = this.items.find((i) => i.name === this.damColorName);
                    const sireColor = this.items.find((i) => i.name === this.sireColorName);

                    if (!damColor || !sireColor) {
                        this.$emit("validation-result", true);
                    }

                    if (damColor.colorValidationRule === "BOTH_PARENTS" && sireColor.colorValidationRule === "BOTH_PARENTS"
                        && this.damColorName === this.sireColorName) {
                        this.$emit("validation-result", this.BOTH_PARENTS(selectedColor));
                    } else if (selectedColor.colorValidationRule === "AT_LEAST_ONE_PARENT") {
                        this.$emit("validation-result", this.AT_LEAST_ONE_PARENT(selectedColor));
                    } else {
                        this.$emit("validation-result", true);
                    }
                }
            },

            BOTH_PARENTS(color) {
                return color.name === this.damColorName && color.name === this.sireColorName;
            },

            AT_LEAST_ONE_PARENT(color) {
                return color.name === this.damColorName || color.name === this.sireColorName;
            },
        },

        components: {CustomSelectOne},
    };
</script>

<style scoped>

</style>
